import apiClient from './api/client';
import ENDPOINTS from './api/endpoints';

export const shiftService = {
  getActiveShift: async () => {
    try {
      const response = await apiClient.get(ENDPOINTS.SHIFTS.ACTIVE);
      return response;
    } catch (error) {
      // 204 No Content means no active shift — not an error
      if (error.response?.status === 204) {
        return null;
      }
      console.error('Failed to fetch active shift:', error);
      throw error;
    }
  },

  startShift: async (openingCash) => {
    try {
      const response = await apiClient.post(ENDPOINTS.SHIFTS.START, {
        openingCash: openingCash != null ? openingCash : 0,
      });
      return response;
    } catch (error) {
      console.error('Failed to start shift:', error);
      throw error;
    }
  },

  endShift: async (id, { actualCash, notes, denomination }) => {
    try {
      const response = await apiClient.post(ENDPOINTS.SHIFTS.END(id), {
        actualCash: actualCash != null ? actualCash : null,
        notes: notes || null,
        denomination: denomination || null,
      });
      return response;
    } catch (error) {
      console.error('Failed to end shift:', error);
      throw error;
    }
  },

  getShiftSummary: async (id) => {
    try {
      const response = await apiClient.get(ENDPOINTS.SHIFTS.SUMMARY(id));
      return response;
    } catch (error) {
      console.error('Failed to fetch shift summary:', error);
      throw error;
    }
  },

  getTodayShifts: async (businessDate) => {
    try {
      const params = businessDate ? { businessDate } : {};
      const response = await apiClient.get(ENDPOINTS.SHIFTS.TODAY, { params });
      return response;
    } catch (error) {
      console.error('Failed to fetch today shifts:', error);
      throw error;
    }
  },

  getShiftConfig: async () => {
    try {
      const response = await apiClient.get(ENDPOINTS.SHIFTS.CONFIG);
      return response;
    } catch (error) {
      console.error('Failed to fetch shift config:', error);
      return { shiftEnabled: false };
    }
  },

  forceCloseShift: async (id, { actualCash, notes, denomination } = {}) => {
    try {
      const body = {};
      if (actualCash != null) body.actualCash = actualCash;
      if (notes) body.notes = notes;
      if (denomination) body.denomination = denomination;
      const response = await apiClient.post(ENDPOINTS.SHIFTS.FORCE_CLOSE(id), body);
      return response;
    } catch (error) {
      console.error('Failed to force close shift:', error);
      throw error;
    }
  },
};

export default shiftService;
